import { Button } from '@mui/material';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';
import * as React from 'react';
export function LabeledButton(props) {
    const { label, className, ...buttonProps } = props;
    return React.createElement(FormControlLabelStyle, { className: className, labelPlacement: "bottom", label: label, control: React.createElement(Box, { className: "LabeledButton-ButtonContainer" },
            React.createElement(LabeledButtonStyle, { ...buttonProps })) });
}
export const FormControlLabelStyle = styled(FormControlLabel, { slot: 'Root' })(({ theme }) => ({
    '&.MuiFormControlLabel-root': {
        margin: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'stretch'
    },
    '& .MuiFormControlLabel-label': {
        ...theme.typography.overline2,
        color: theme.palette.text.secondary,
    },
    '& .LabeledButton-ButtonContainer': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    }
}));
export const LabeledButtonStyle = styled(Button, { slot: 'Root' })(({ theme }) => ({
    '&.MuiButton-root': {
        marginBottom: theme.spacing(1.5),
        minWidth: 0,
        '&.MuiButton-sizeLarge': {
            padding: '1rem 1.75rem',
            '& .MuiSvgIcon-root': {
                fontSize: '1.75rem'
            },
        },
        '&.MuiButton-sizeMedium': {
            padding: '1rem',
            '& .MuiSvgIcon-root': {
                fontSize: '1.75rem'
            },
        },
        '&.MuiButton-sizeSmall': {
            padding: '0.625rem',
            '& .MuiSvgIcon-root': {
                fontSize: '1rem'
            },
        }
    }
}));
//# sourceMappingURL=LabeledButton.js.map